/* eslint-disable @typescript-eslint/no-misused-promises */
import { useStyletron } from "baseui";
import { Textarea } from "baseui/textarea";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import type { ChatbotSession } from "web/src/client-state-trees/ChatbotSession";
import { ChatbotChatMessage } from "./ChatbotChatMessage";

export const ChatbotChat = observer<{ session: ChatbotSession; user?: { email: string } }>(({ session, user }) => {
  const [css, $theme] = useStyletron();

  return (
    <section
      className={css({
        paddingBottom: $theme.sizing.scale400,
        display: "flex",
        flexDirection: "column",
      })}
    >
      {session.messages.map((message) => (
        <ChatbotChatMessage key={message.key} message={message} user={user} />
      ))}

      <div>
        <form
          onSubmit={useCallback(
            (e) => {
              e.preventDefault();
              void session.submitPrompt();
            },
            [session]
          )}
        >
          <Textarea
            value={session.prompt}
            onChange={(e) => {
              session.setPrompt(e.currentTarget.value);
            }}
            placeholder={session.started ? "Reply ... " : "Ask a question..."}
            autoComplete="off"
            autoFocus
            overrides={{
              Input: {
                style: {},
              },
              InputContainer: {
                style: {
                  width: "100%",
                  maxHeight: "200px",
                },
              },
            }}
            onKeyPress={useCallback(
              (e) => {
                // submit the chat if the user hits enter
                // enter a newline if they hit shift+enter
                if (e.key === "Enter" && e.shiftKey == false) {
                  e.preventDefault();
                  void session.submitPrompt();
                }
              },
              [session]
            )}
          />
        </form>
      </div>
    </section>
  );
});
